import React from 'react';
import styled from 'styled-components';
import { IconBookmark } from '../../icon/IconBookmark';
import { IconBookmarkFilled } from '../../icon/IconBookmarkFilled';
import { IconLike } from '../../icon/IconLike';
import { IconThumbUp } from '../../icon/IconThumbUp';
import { IconThumbUpFilled } from '../../icon/IconThumbUpFilled';
import { Box } from '../../layout/Box';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Flex } from '../../layout/Flex';

const ICON_COLOR = 'var(--color-primary)';

export const Container = styled(Box)
    .withConfig({ displayName: 'Container' })
    .attrs({
        width: { xs: '100%', sm: 'auto' },
        backgroundColor: { xs: 'var(--background-primary-blur)', sm: 'var(--background-primary)' },
        backdropFilter: { xs: 'blur(25px)', sm: 'none' },
        transform: { xs: 'translate3d(0, 0, 0)', sm: 'translate3d(-50%, 0, 0)' },
        borderRadius: { xs: 0, sm: '1000px' },
        left: { xs: 0, sm: '50%' },
        bottom: { xs: 0, sm: 2 },
        zIndex: 1,
        boxShadow: { xs: 'none', sm: '0px 1px 2px var(--control-secondary-background)' },
    })`
    transition-property: background-color, backdrop-filter;
    transition-duration: 250ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
    position: absolute;
`;

export const ContentContainer = styled(Flex)
    .withConfig({ displayName: 'ContentContainer' })
    .attrs({
        direction: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: { xs: 2, sm: 1 },
        spacing: 0.5,
    })``;

export const TextFreeButton = styled(Box).withConfig({ displayName: 'TextFreeButton' }).attrs({
    backgroundColor: 'var(--control-secondary-background)',
    p: 1.5,
    borderRadius: '100%',
})``;

export const LikeThumbFilledIcon = () => (
    <IconThumbUpFilled size={24} color={ICON_COLOR} dataTestId={DataTestId.FILLED} />
);

export const LikeThumbIcon = () => (
    <IconThumbUp size={24} color={ICON_COLOR} dataTestId={DataTestId.EMPTY} />
);

export const BookmarkFilledIcon = () => (
    <IconBookmarkFilled fontSize={24} color={ICON_COLOR} dataTestId={DataTestId.FILLED} />
);

export const BookmarkIcon = () => (
    <IconBookmark fontSize={24} color={ICON_COLOR} dataTestId={DataTestId.EMPTY} />
);

export const FavoriteHeartIcon = ({ isActive }: { isActive: boolean }) => (
    <IconLike
        size={24}
        strokeWidth="2px"
        stroke={ICON_COLOR}
        fill={isActive ? ICON_COLOR : 'transparent'}
        dataTestId={isActive ? DataTestId.FILLED : DataTestId.EMPTY}
    />
);
